var g_devtricker_current_child_comment_offset = {};
var g_devtricker_showing_children = {};
var g_devtricker_replies_original_text = {};
var g_devtricker_current_main_thread_comment_offset = 10;
var g_devtricker_allow_comment_load_request = true;
var g_devtricker_comment_order_by = 'relevance';

async function devtricker_loadCommentChildren(event, button, commentId) {

    if (!devtricker_getTheLoggedUserId()) {
        devtricker_openSocialLoginModal();
        return;
    }

    button.disabled = true;

    if (!g_devtricker_current_child_comment_offset.hasOwnProperty(commentId)) {
        g_devtricker_current_child_comment_offset[commentId] = 0;
    }

    let parentSelector = `#li-comment-${commentId} .children`;

    let placeholder = devtricker_insertPlaceholderComment_v2(parentSelector, true);

    try {

        let commentWrapper = await devtricker_ajax_getComments(commentId, g_devtricker_current_child_comment_offset[commentId]);

        if (commentWrapper && commentWrapper.comments.length > 0) {

            placeholder.remove();

            devtricker_insertComment_v2(commentWrapper.comments, parentSelector, true);

            g_devtricker_current_child_comment_offset[commentId] += 3;

            devtricker_changeRepliesButtonToHideButton(event, button, commentId);

            if (commentWrapper.hasNext) {
                devtricker_addLoadMoreChildComments(commentId, parentSelector, commentWrapper.remainingComments);
            }

            button.disabled = false;

            devtricker_process_initializeAllHovercards();
            devtricker_initializeOtherCommentOption();
            devtricker_initializeCodeHighlights();
            // devtricker_initializeLikedFill();

        } else {
            placeholder.remove();
        }
    } catch (error) {
        devtricker_showCommentErrorToast();
        button.disabled = false;
    }
}

function devtricker_changeRepliesButtonToHideButton(event, button, commentId) {

    let parentCommentButton = document.querySelector(`#li-comment-${commentId} .reply-counter`);

    if (parentCommentButton) {

        let textElement = parentCommentButton.querySelector('.reply-counter-text');

        if (!g_devtricker_replies_original_text[commentId]) {
            g_devtricker_replies_original_text[commentId] = textElement.innerText;
        }

        devtricker_dom_comment_setChevronIconStyle(commentId, 'up');

        parentCommentButton.onclick = function (event) {
            devtricker_hideCommentChildren(event, button, commentId);
        };
    }

}

function devtricker_hideCommentChildren(event, button, commentId) {

    let parentCommentButton = document.querySelector(`#li-comment-${commentId} .reply-counter`);
    let children = document.querySelector(`#li-comment-${commentId} > ol`);

    children.style.display = 'none';

    let textElement = parentCommentButton.querySelector('.reply-counter-text');

    textElement.innerText = g_devtricker_replies_original_text[commentId];

    devtricker_dom_comment_setChevronIconStyle(commentId, 'down');

    parentCommentButton.onclick = function (event) {
        devtricker_showCommentChildren(event, button, commentId);
    };
}

function devtricker_showCommentChildren(event, button, commentId) {

    let parentCommentButton = document.querySelector(`#li-comment-${commentId} .reply-counter`);
    let children = document.querySelector(`#li-comment-${commentId} > ol`);

    children.style.display = 'block';

    devtricker_dom_comment_setChevronIconStyle(commentId, 'up');

    parentCommentButton.onclick = function (event) {
        devtricker_hideCommentChildren(event, button, commentId);
    };
}

let offcanvasCommentBody = document.querySelector('.offcanvas-body');

if (offcanvasCommentBody) {

    offcanvasCommentBody.addEventListener('scroll', async function () {
        await loadCommentMainThread(offcanvasCommentBody);
    });
}

async function loadCommentMainThread(offcanvasCommentBody) {
    if (g_devtricker_allow_comment_load_request) {

        if (offcanvasCommentBody.scrollTop + offcanvasCommentBody.clientHeight >= offcanvasCommentBody.scrollHeight - 10) {

            g_devtricker_allow_comment_load_request = false;

            let parentSelector = '.comment-list';

            if (!devtricker_getTheLoggedUserId()) {
                devtricker_openSocialLoginModal();
                return;
            }

            let placeholder = devtricker_insertPlaceholderComment_v2(parentSelector, true);

            try {

                let commentWrapper = await devtricker_ajax_getComments(0, g_devtricker_current_main_thread_comment_offset);

                placeholder.remove();

                if (commentWrapper.comments.length == 0) {
                    return;
                } else {
                    devtricker_insertComment_v2(commentWrapper.comments, parentSelector, true);
                }

                if (commentWrapper.hasNext) {
                    g_devtricker_allow_comment_load_request = true;
                    g_devtricker_current_main_thread_comment_offset += 10;
                }

            } catch (error) {
                devtricker_showCommentErrorToast();
            }

            devtricker_process_initializeAllHovercards();
            devtricker_initializeOtherCommentOption();
            devtricker_initializeCodeHighlights();
            // devtricker_initializeLikedFill();
        }
    }
}

document.addEventListener('DOMContentLoaded', function () {
    if (!devtricker_getTheLoggedUserId()) {
        let loadMoreOffset = document.getElementById('load-more-1-level-comments');
        if (loadMoreOffset) {
            loadMoreComment.classList.add('d-none');
        }
    }
});